<template>
  <div>
    <span>{{ item }}</span>
  </div>
</template>

<script>
export default {
  name: 'CustomFieldAutoCompleteTemplate',
  props: {
    item: {
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// CustomFieldAutoCompleteTemplate.vue?8ea3964e